export const environment = {
    production: true,
    maintenance: false,

    apiDomain: 'qual-hapy.bizzdev.net',
    apiUrl: 'https://qual-hapy.bizzdev.net/api/',
    identityApiUrl: 'https://qual-hapy.bizzdev.net/identity/',

    tokenKey: 'token',
    tokenExpKey: 'token-exp',
    rfTokenKey: 'rf-token',

    version: require('../../package.json').version
};
